import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { headers } from '../apiConfig';

import { getServerUrl } from '../../Utils/serverSelector'; 

// Получить отзывы по `uid` мастера
export const fetchAllReviews = createAsyncThunk(
  'reviews/fetchReviews',
  async (uid) => {
    const response = await axios.get(
      `${getServerUrl()}/reviews/${uid}`,
      { headers }
    );
    return response.data;
  }
);

// Добавить новый отзыв
export const addReview = createAsyncThunk(
  'reviews/addReview',
  async (reviewData) => {
    const response = await axios.post(
      `${getServerUrl()}/reviews`,
      reviewData,
      { headers }
    );
    return response.data;
  }
);

const initialState = {
  reviews: [],
  status: 'idle',
  error: null,
};

const reviewsSlice = createSlice({
  name: 'reviews',
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllReviews.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchAllReviews.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.reviews = action.payload;
      })
      .addCase(fetchAllReviews.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      })
      .addCase(addReview.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(addReview.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.reviews.push(action.payload);
      })
      .addCase(addReview.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      });
  },
});

export default reviewsSlice.reducer;
